import * as XLSX from 'xlsx'
import { removeDuplicatesFromObjectArr } from '@/core/utils/common.js'
import { viewPdf } from '.'

export const parseExcel = (file, configs, cb) => {
  if (file) {
    const excelFile = file.raw
    excelToJson(excelFile, configs, cb)
  } else {
    cb(null, 'No file specified!')
  }
}

const excelToJson = (excelFile, configs, callback) => {
  const reader = new FileReader()
  reader.onload = function (e) {
    const data = e.target.result
    const result = XLSX.read(data, {
      type: 'binary',
      cellDates: true // 为了获取excel表格中的时间，返回格式为世界时间
    })
    // 格式化数据
    const [res, errors] = formatResult(result, configs)
    callback(removeDuplicatesFromObjectArr(res), errors)
  }
  reader.onerror = function (e) {
    callback(null, e)
  }
  reader.readAsArrayBuffer(excelFile)
}

// 将读取的数据转成JSON
const formatResult = (data, configs) => {
  // 获取总数据
  const sheets = data.Sheets
  // 只读取第一个sheet
  const sheetItem = Object.keys(sheets)[0]
  // 获取
  const sheetJson = XLSX.utils.sheet_to_json(sheets[sheetItem], { header: 1 })
  // 格式化Item时间数据
  formatItemDate(sheetJson)
  // 格式化Item合并数据
  formatItemMerge(sheets[sheetItem], sheetJson)
  const [listData, errors] = formatCheck(sheetJson, configs)
  // 返回数据
  return [listData, errors]
}

const formatItemDate = data => {
  data.forEach(row => {
    row.forEach((item, index) => {
      if (typeof data === 'string') row[index] = item.trim()
      // 若有数据为时间格式则格式化时间
      if (item instanceof Date) {
        // 坑：这里因为XLSX插件源码中获取的时间少了近43秒，所以在获取凌晨的时间上会相差一天的情况,这里手动将时间加上
        const date = new Date(Date.parse(item) + 43 * 1000)
        row[index] = `${date.getFullYear()}-${String(
          date.getMonth() + 1
        ).padStart(2, 0)}-${String(date.getDate()).padStart(2, 0)}`
      }
    })
  })
}

// 格式化Item合并数据
const formatItemMerge = (sheetItem, data) => {
  // 保存每一项sheet中的合并单元格记录
  const merges = sheetItem['!merges'] || []
  merges.forEach(el => {
    const start = el.s
    const end = el.e
    // 处理行合并数据
    if (start.r === end.r) {
      const item = data[start.r][start.c]
      for (let index = start.c; index <= end.c; index++) {
        data[start.r][index] = item
      }
    }
    // 处理列合并数据
    if (start.c === end.c) {
      let item
      if (data[0][start.c] === 'KGS' || data[0][start.c] === 'CBM') {
        item = data[start.r][start.c] / (end.r - start.r + 1)
      } else {
        item = data[start.r][start.c]
      }

      for (let index = start.r; index <= end.r; index++) {
        data[index][start.c] = item
      }
    }
  })
}

const formatCheck = (sheetJson, configs) => {
  sheetJson = sheetJson.filter(one => one.filter(two => two).length > 0)
  const sheetHeaders = sheetJson[0]
  const errors = []
  const headerDefined = {}
  configs.headers.forEach(header => {
    if (!sheetHeaders.includes(header.header)) {
      errors.push({
        msg: `${header.header} not included in first sheet of excel!`
      })
    } else {
      headerDefined[header.header] = {
        ...header,
        index: Object.keys(sheetHeaders).find(
          key => sheetHeaders[key] === header.header
        )
      }
    }
  })
  if (errors.length !== 0) return [[], errors.map(e => e.msg)]
  const results = sheetJson.slice(1).map(() => ({}))
  Object.values(headerDefined).forEach(header => {
    const headerKey = header.key
    const headerIndex = header.index
    for (let i = 0; i < sheetJson.length - 1; i++) {
      const rowValue = sheetJson[i + 1][headerIndex]
      header.validators.forEach(validator => {
        const [flag, error] = validator(rowValue)
        if (!flag) {
          errors.push({
            msg: `${i + 1} row, ${header.label} column has invalid value ${rowValue}, error ${error}`
          })
        }
      })
      results[i][headerKey] = header.convertor(rowValue)
    }
  })
  return [results, errors.length ? errors.map(e => e.msg) : []]
}

export const exportExcel = excelInfo => {
  const workbook = XLSX.utils.book_new()
  excelInfo.forEach(info => {
    const worksheet = XLSX.utils.json_to_sheet(info.rows, {
      header: info.columns
    })
    XLSX.utils.book_append_sheet(workbook, worksheet, info.sheetName)
  })
  const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' })
  const excelData = new Blob([excelBuffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  })
  // saveAs(excelData, 'goods.xlsx')
  viewPdf(excelData)
}

export const downloadExcel = () => {
  const workbook = XLSX.utils.book_new()
  const worksheet = XLSX.utils.aoa_to_sheet([
    [
      '提单号码',
      '柜号',
      '仓库代码',
      'MARKS',
      'SHIPMENT ID',
      'REFERENCE ID',
      'QTY',
      'KGS',
      'CBM',
      '派送方式',
      '派送地点',
      'Note',
      'FBA预约时间',
      'PRO NO.'
    ]
  ])

  XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1')

  XLSX.writeFile(workbook, 'template.xlsx')
}

export function dumpBusinessShippingDailyReport(records, date) {
  const aliasMap = {
    poNo: {
      alias: 'Purchase No.',
      order: 0
    },
    riiOrderNo: {
      alias: 'RII Order No.',
      order: 1
    },
    carrierName: {
      alias: 'Carrier Name',
      order: 2
    },
    proNo: {
      alias: 'PRO No.',
      order: 3
    },
    bolNo: {
      alias: 'BOL No.',
      order: 4
    },
    arnNo: {
      alias: 'ARN No.',
      order: 5
    },
    productNo: {
      alias: 'Product No.',
      order: 6
    },
    productName: {
      alias: 'Product Name',
      order: 7
    },
    serialNo: {
      alias: 'Serial No.',
      order: 8
    },
    sscc: {
      alias: 'SSCC',
      order: 9
    }
  }

  const sortedRecords = records.map(record => {
    const sortedRecord = {}
    Object.keys(record)
      .sort((a, b) => {
        return (aliasMap[a]?.order ?? 0) - (aliasMap[b]?.order ?? 0)
      }).forEach(key => {
        const alias = aliasMap[key].alias || key
        sortedRecord[alias] = record[key]
      })
    return sortedRecord
  })

  const workbook = XLSX.utils.book_new()
  const worksheet = XLSX.utils.json_to_sheet(sortedRecords)
  XLSX.utils.book_append_sheet(workbook, worksheet, date)
  const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' })
  const excelData = new Blob([excelBuffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  })
  const link = document.createElement('a')
  link.href = URL.createObjectURL(excelData)
  link.download = `${date}.xlsx`
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}
